import React from "react";
import { Field } from "react-final-form";
import { CentsInput } from "../../../components/inputs/final_form/MoneyInput";
import { PercentInput } from "../../../components/inputs/final_form/PercentInput";
import { TextInput } from "../../../components/inputs/final_form/TextInput";
import { LoadingButton } from "../../../components/LoadingButton";
import { atLeastOneFieldWithMoneyRequired, required } from "../../../util/validators";
import { AdministrateSelectInput, AdminOptionableInput } from "../../components/inputs/AdministrateSelectInput";

export const FeeScheduleByPayorForm = ({ handleSubmit, submitting, create = true }) => {
  return (
    <>
      <Field component={TextInput} type="hidden" name="labId" />

      {create && (
        <>
          <Field
            component={AdminOptionableInput}
            resource="payors"
            label="Payor"
            name="payorId"
            searchParam="name"
            required
            validate={required}
          />
          <Field
            component={AdministrateSelectInput}
            resourceUrl="/admin/cpt_codes.json"
            label="CPT Code"
            name="cptCodeId"
            required
            validate={required}
          />
        </>
      )}
      <Field component={CentsInput} validate={atLeastOneFieldWithMoneyRequired("medicarePercentage")} label="Price" name="priceCents" />
      <Field
        component={PercentInput}
        validate={atLeastOneFieldWithMoneyRequired("priceCents")}
        label="Medicare Percentage"
        name="medicarePercentage"
      />
      <LoadingButton loading={submitting} onClick={handleSubmit} disabled={submitting}>
        Submit
      </LoadingButton>
    </>
  );
};
